import { html, type Html, View } from 'rune-ts';
import { Dropdown, DropdownChangeEvent, type DropdownOption } from '../../../Dropdown/Dropdown';
import { changeUrlLang } from '../../../../../../shared/util';
import { font, type Lang } from '../../../../../../shared/typography';
import { isApp } from '../../../../../../shared/app/util';
import { MShopUtilF } from '@modules/MShop/Util/F/Function/module/MShopUtilF';
import { loading } from '../../../../../../shared/client/global';
import { makeMainUrl } from '../../../../../../shared/util/url';
import klass from './UtilityNav.module.scss';

const LANG_OPTIONS: DropdownOption<Lang>[] = [
  { key: 'kr', value: 'kr', name: '한국어' },
  { key: 'en', value: 'en', name: 'English' },
  { key: 'jp', value: 'jp', name: '日本語' },
];

export interface UtilityNavData {
  lang: Lang;
  is_login: boolean;
  dropdown_klass?: string;
  dropdown_button_klass?: string;
}

export class UtilityNav extends View<UtilityNavData> {
  override template(): Html {
    const { is_login } = this.data;

    return html`
      <div class="${klass.utility_nav} ${font('14_medium')}">
        <div class="${klass.left}">
          <a href="${makeMainUrl(`/${ET.lang}`)}" class="${klass.link}"
            >${ET.lang === 'kr' ? '마플샵' : 'MarppleShop'}</a
          >
          <span class="${klass.divider}"></span>
          <a href="https://www.marpple.com/${ET.lang}" target="_blank" class="${klass.link}"
            >${ET.lang === 'kr' ? '마플' : 'MARPPLE'}</a
          >
        </div>
        <div class="${klass.right}">
          <div class="${klass.login}">
            ${is_login
              ? html`<a href="/${ET.lang}/logout" class="${klass.link}">${ET('mps2::mypage::logout')}</a>`
              : html`
                  <a href="/${ET.lang}/login" class="${klass.link}">${ET('mps2::signup::signin')}</a>
                  <a href="/${ET.lang}/login?is_join=true" class="${klass.link}"
                    >${ET('mps2::signup::signup')}</a
                  >
                `}
          </div>
          ${new Dropdown(
            { selected_option_key: this.data.lang, options: LANG_OPTIONS },
            {
              horizontal: 'right',
              vertical: 'bottom',
              has_arrow: true,
              text_align: 'left',
              use_px_system: true,
              without_container: true,
              klass: `${klass.lang_dropdown} ${this.data.dropdown_klass ?? ''}`,
              button_klass: `${this.data.dropdown_button_klass ?? ''} ${font('14_medium')}`,
            },
          )}
        </div>
      </div>
    `;
  }

  override onRender() {
    const current_url = location.pathname + location.search;
    this.element()
      .querySelectorAll<HTMLAnchorElement>(`.${klass.login} a`)
      .forEach((a) => {
        a.href += `${a.href.includes('?') ? '&' : '?'}url=${current_url}`;
      });

    this.delegate(DropdownChangeEvent<Lang>, Dropdown, (e) => {
      if (!e.detail.option) return;

      if (isApp()) {
        loading();
        MShopUtilF.postMessage({ locale: e.detail.option.value });
        return;
      }

      location.href = changeUrlLang(location.href, e.detail.option.value);
    });
  }
}
